export type LodgingTypeConfigValue = {
    field: string
    id: string
}
export type LocaleLodgingTypeConfig = {
    label: string
    values: LodgingTypeConfigValue[]
}[]
export type LodgingTypeConfig = {
    [locale: string]: LocaleLodgingTypeConfig
}

const lodgingTypeConfig: LodgingTypeConfig = {
    fr_FR: [
        {
            label: 'Résidence de Tourisme',
            values: [
                {
                    field: 'lodgingType',
                    id: '19'
                }
            ]
        },
        {
            label: 'Résidence de Tourisme 4* et 5*',
            values: [
                {
                    field: 'lodgingType',
                    id: '43'
                }
            ]
        },
        {
            label: 'Chalet',
            values: [
                {
                    field: 'lodgingType',
                    id: '18'
                }
            ]
        },
        {
            label: 'Chalet Premium',
            values: [
                {
                    field: 'lodgingType',
                    id: '44'
                }
            ]
        },
        {
            label: 'Clubs Vacances',
            values: [
                {
                    field: 'lodgingType',
                    id: '23'
                }
            ]
        },
        {
            label: 'Appartement de particulier',
            values: [
                {
                    field: 'lodgingType',
                    id: '40'
                }
            ]
        },
        {
            label: 'Hôtel',
            values: [
                {
                    field: 'lodgingType',
                    id: '22'
                }
            ]
        },
        {
            label: 'Appartement Premium',
            values: [
                {
                    field: 'lodgingType',
                    id: '45'
                }
            ]
        },
        {
            label: 'Auberge de jeunesse ',
            values: [
                {
                    field: 'lodgingType',
                    id: '41'
                }
            ]
        }
    ],
    en_US: [
        {
            label: 'Tourist residence',
            values: [
                {
                    field: 'lodgingType',
                    id: '19'
                }
            ]
        },
        {
            label: '4 and 5* tourist residence',
            values: [
                {
                    field: 'lodgingType',
                    id: '43'
                }
            ]
        },
        {
            label: 'Chalet',
            values: [
                {
                    field: 'lodgingType',
                    id: '18'
                }
            ]
        },
        {
            label: 'Premium chalet',
            values: [
                {
                    field: 'lodgingType',
                    id: '44'
                }
            ]
        },
        {
            label: 'Hotel club',
            values: [
                {
                    field: 'lodgingType',
                    id: '23'
                }
            ]
        },
        {
            label: 'Private apartment',
            values: [
                {
                    field: 'lodgingType',
                    id: '40'
                }
            ]
        },
        {
            label: 'Hotel',
            values: [
                {
                    field: 'lodgingType',
                    id: '22'
                }
            ]
        },
        {
            label: 'Premium apartment',
            values: [
                {
                    field: 'lodgingType',
                    id: '45'
                }
            ]
        }
    ],
    nl_NL: [
        {
            label: 'Residence',
            values: [
                {
                    field: 'lodgingType',
                    id: '19'
                }
            ]
        },
        {
            label: 'Residence 4 en 5*',
            values: [
                {
                    field: 'lodgingType',
                    id: '43'
                }
            ]
        },
        {
            label: 'Chalet',
            values: [
                {
                    field: 'lodgingType',
                    id: '18'
                }
            ]
        },
        {
            label: 'Premium Chalet',
            values: [
                {
                    field: 'lodgingType',
                    id: '44'
                }
            ]
        },
        {
            label: 'Hotel club',
            values: [
                {
                    field: 'lodgingType',
                    id: '23'
                }
            ]
        },
        {
            label: 'Privéappartement',
            values: [
                {
                    field: 'lodgingType',
                    id: '40'
                }
            ]
        },
        {
            label: 'Hotel',
            values: [
                {
                    field: 'lodgingType',
                    id: '22'
                }
            ]
        },
        {
            label: 'Premium Appartement',
            values: [
                {
                    field: 'lodgingType',
                    id: '45'
                }
            ]
        }
    ]
}

export default lodgingTypeConfig
